import { render, staticRenderFns } from "./TestItemContainer.vue?vue&type=template&id=583735ea&scoped=true&"
import script from "./TestItemContainer.vue?vue&type=script&lang=js&"
export * from "./TestItemContainer.vue?vue&type=script&lang=js&"
import style0 from "./TestItemContainer.vue?vue&type=style&index=0&id=583735ea&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583735ea",
  null
  
)

export default component.exports